import { useAppSelector } from '@frontend/common';
import { DimensionConstraintData, isDimensionConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { DimensionConstraintDataInputProps } from './dimension-constraint-data-input.component';

interface ViewProps {
    formValues: DimensionConstraintData;
}

const useDimensionConstraintDataInput = (props: DimensionConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isDimensionConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { height: 0, width: 0, depth: 0 } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useDimensionConstraintDataInput;
